import posthog from 'posthog-js';
import CONSTANTS from 'shared/constants';
import { classifyRoute } from 'shared/analytics/route-class';

// Anonymous email/preview flows are the biggest DAU inflator (CIN-6355), so we
// skip PostHog entirely on /unsubscribe (email recipients never log in — full
// tracking creates permanent ghost persons) and on /customer-drawer when it's an
// iframe embed on an external site (parent tool is already tracking the same
// user, so init here doubles sessions/events). Direct hits on /customer-drawer
// on our own site still track normally.
const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
const isInIframe = (() => {
  if (typeof window === 'undefined') return false;
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin access to window.top throws — that itself proves we're
    // embedded on a different-origin parent (i.e., an external site).
    return true;
  }
})();
const skipInit = pathname.startsWith('/unsubscribe/') || pathname.startsWith('/customer-drawer') && isInIframe;

// Stamped at capture time rather than registered once, so the label and the
// public-page flag follow the user through in-app navigation (CIN-6465).
const stampRouteClass = event => {
  if (!event || event.event === '$snapshot') return event;
  const {
    routeClass,
    isPublicRoute
  } = classifyRoute(event.properties?.$pathname || window.location.pathname);
  if (routeClass === 'unsubscribe') return null;
  event.properties = {
    ...event.properties,
    route_class: routeClass,
    is_public_route: isPublicRoute
  };
  return event;
};
if (!skipInit && CONSTANTS.ENV !== 'LOCAL') {
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    capture_exceptions: true,
    capture_pageview: 'history_change',
    before_send: stampRouteClass,
    session_recording: {
      captureCanvas: {
        recordCanvas: true,
        canvasFps: 2,
        canvasQuality: '0.2'
      }
    }
  });

  // Older builds persisted these as super-properties; clear them so the
  // capture-time values above are the only source.
  posthog.unregister('route_class');
  posthog.unregister('is_public_route');

  // Super-properties: attached to every subsequent event automatically. Enables
  // dashboards to filter to "real logged-in app users" (product_area = cinch_app
  // AND is_public_route = false AND is_internal_user = false — the last set on
  // identify in user-state-context).
  posthog.register({
    product_area: 'cinch_app'
  });
}
export default posthog;